import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight, FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import './FinalCTA.css';

const FinalCTA = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  const navigate = useNavigate();

  return (
    <section className="final-cta" id="cta" ref={ref}>
      <div className="final-cta__bg" aria-hidden="true" />
      <div className="final-cta__particles" aria-hidden="true">
        {[...Array(8)].map((_, i) => {
          const handleSpark = (e) => {
            const el = e.currentTarget;
            el.style.pointerEvents = 'none';
            el.style.background = '#ffd700';
            el.style.boxShadow = '0 0 20px #ffd700, 0 0 40px #ffd700';
            el.style.transform = 'scale(3)';
            el.style.transition = 'transform 0.5s ease-out, opacity 0.5s ease-out';
            el.style.opacity = '0';
            setTimeout(() => {
              el.style.pointerEvents = 'auto';
              el.style.background = '';
              el.style.boxShadow = '';
              el.style.transform = '';
              el.style.transition = '';
              el.style.opacity = '';
            }, 5000);
          };
          return (
            <span
              key={i}
              className="particle"
              style={{ '--i': i, cursor: 'crosshair', pointerEvents: 'auto' }}
              onClick={handleSpark}
            />
          );
        })}
      </div>

      <motion.div
        className="final-cta__content"
        initial={{ opacity: 0, y: 40 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
      >
        <motion.span
          className="final-cta__eyebrow"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 0.2 }}
        >
           Ready to Transform?
        </motion.span>

        <h2 className="final-cta__title">
          Let's Build Your Business's<br />
          <span className="final-cta__highlight">Technology Future — Together</span>
        </h2>

        <p className="final-cta__subtitle">
          Get a free consultation from our certified experts. No commitment required.
          We'll map out the perfect solution for your specific business needs.
        </p>

        <div className="final-cta__actions">
          <button
            className="final-cta__btn final-cta__btn--primary"
            onClick={() => navigate('/contact')}
          >
            <FaPhoneAlt />
            Book Free Consultation
          </button>

          <a
            className="final-cta__btn final-cta__btn--whatsapp"
            href="https://wa.me/919841609990"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp />
            Chat on WhatsApp
          </a>

          <button
            className="final-cta__btn final-cta__btn--ghost"
            onClick={() => navigate('/solutions')}
          >
            Explore Solutions <FaArrowRight />
          </button>
        </div>

        <div className="final-cta__trust">
          <span>✓ Free Consultation</span>
          <span>✓ No Hidden Costs</span>
          <span>✓ 20+ Years Experience</span>
          <span>✓ Tally 5-Star Partner</span>
        </div>
      </motion.div>
    </section>
  );
};

export default FinalCTA;
